
export default {
    seekerFieldByCode: (state) => (code) => {
        return state.seeker_fields.find(o => o.code == code) || {};
    },
    seekerTabByCode: (state) => (code) => {
        const showField = state.seeker_fields.find(o => { return o.tab_code == code && !o.is_hidden; });
        return {
            is_hidden: !showField,
        };
    },
    seekerSectionByCode: (state) => (code) => {
        const showField = state.seeker_fields.find(o => { return o.section_code == code && !o.is_hidden; });
        return {
            is_hidden: !showField,
        };
    },
};
